import React, { useContext, useState } from 'react'
import './LoginPopup.css'
import { useTranslation } from 'react-i18next';
import { assets } from '../../assets/assets'
import { StoreContext } from '../../Context/StoreContext'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'

const LoginPopup = ({ setShowLogin, setShowResetPassword }) => {
    const { t } = useTranslation();

    const { setToken, url, loadCartData, fetchUserData } = useContext(StoreContext)
    const [currState, setCurrState] = useState("Sign Up");
    const [showPassword, setShowPassword] = useState(false);

    const [data, setData] = useState({
        name: "",
        email: "",
        password: ""
    })

    const onChangeHandler = (event) => {
        const name = event.target.name
        const value = event.target.value
        setData(data => ({ ...data, [name]: value }))
    }

    const onLogin = async (e) => {
        e.preventDefault()

        try {
            let new_url = url;
            if (currState === "Login") {
                new_url += "/api/user/login";
            }
            else {
                new_url += "/api/user/register"
            }
            
            console.log("Sending registration data:", data);
            console.log("Target URL:", new_url);
            
            const response = await axios.post(new_url, data);
            if (response.data.success) {
                const userToken = response.data.token;
                setToken(userToken);
                localStorage.setItem("token", userToken);
                
                // Check if this is a login (which returns a token)
                if (userToken) {
                    // Load both cart and user data in parallel
                    await Promise.all([
                        loadCartData(userToken),
                        fetchUserData(userToken)
                    ]);
                }
                
                toast.success(currState === "Login" ? "Login successful!" : "Account created successfully!");
                setShowLogin(false);
            }
            else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Authentication error:", error);
            console.error("Full error response:", error.response);
            const errorMessage = error.response?.data?.message || error.message || "Authentication failed. Please try again.";
            console.error("Error message to display:", errorMessage);
            toast.error(errorMessage);
        }
    }

    const handleForgotPassword = () => {
        setShowLogin(false);
        setShowResetPassword(true);
    };

    return (
        <div className='login-popup'>
            <form onSubmit={onLogin} className="login-popup-container">
                <div className="login-popup-title">
                    <h2>{currState}</h2> <img onClick={() => setShowLogin(false)} src={assets.cross_icon} alt="" />
                </div>
                <div className="login-popup-inputs">
                    {currState === "Sign Up" ? <input name='name' onChange={onChangeHandler} value={data.name} type="text" placeholder='Your name' required /> : <></>}
                    <input name='email' onChange={onChangeHandler} value={data.email} type="email" placeholder='Your email' required />
                    <div className="password-input-container">
                        <input 
                            name='password' 
                            onChange={onChangeHandler} 
                            value={data.password} 
                            type={showPassword ? "text" : "password"} 
                            placeholder='Password' 
                            required 
                        />
                        <button 
                            type="button" 
                            className="password-toggle-btn"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 3l18 18M10.5 10.5a3 3 0 1 0 4.24 4.24m1.06-5.76a3 3 0 0 0-5.3-5.3M12 5c-4.48 0-8.4 2.8-10 7 .6 1.6 1.6 3 2.8 4.1m2.2 1.4c1.6.6 3.3.9 5 .9 4.48 0 8.4-2.8 10-7-.7-1.8-1.8-3.3-3.1-4.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            ) : (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
                <button>{currState === "Login" ? "Login" : "Create account"}</button>
                
                {currState === "Login" && (
                    <div className="forgot-password-link">
                        <button 
                            type="button" 
                            onClick={handleForgotPassword}
                            className="forgot-password-btn"
                        >
                            Forgot Password?
                        </button>
                    </div>
                )}
                
                <div className="login-popup-condition">
                    <input type="checkbox" name="" id="" required/>
                    <p>
                      By continuing, I agree to the <Link to="/terms">terms of use</Link> &{' '}
                      <Link to="/privacy">privacy policy</Link>.
                    </p>
                </div>
                {currState === "Login"
                    ? <p>Create a new account? <span onClick={() => setCurrState('Sign Up')}>Click here</span></p>
                    : <p>Already have an account? <span onClick={() => setCurrState('Login')}>Login here</span></p>
                }
            </form>
        </div>
    )
}

export default LoginPopup
